import { render, staticRenderFns } from "./addOrderByExcelUploadPage.vue?vue&type=template&id=56d1361c&"
import script from "./addOrderByExcelUploadPage.vue?vue&type=script&lang=js&"
export * from "./addOrderByExcelUploadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports